// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { EURO_TEXT } = require('constants/index');
const PERCENT = '%';

const initialState = Immutable.fromJS({
    data: [],
    isFetching: false,
    error: null,
    selectedOption: EURO_TEXT,
    chartButtons: [EURO_TEXT, PERCENT],
});

const parseResponse = (state, response) => {
    response.forEach(d => (d.percentValue = d.timeWeightedReturn * 100));
    return state.merge({ data: response, isFetching: false, error: null });
};

const RAEvolutionChartOjectiveTracking = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_OBJ_TRACKING_EVOLUTION_REQUEST:
            return state.merge({ isFetching: true, error: null, data: [] });
        case actionTypes.RA_OBJ_TRACKING_EVOLUTION_CHANGE_OPTION:
            return state.merge({ selectedOption: action.payload.value });
        case actionTypes.RA_OBJ_TRACKING_EVOLUTION_FAILURE:
            return state.merge({ isFetching: false, error: true });
        case actionTypes.RA_OBJ_TRACKING_EVOLUTION_SUCCESS:
            return parseResponse(state, action.payload.data.valuations);
        default:
            return state;
    }
};

module.exports = RAEvolutionChartOjectiveTracking;
